<template>
    <div class="data-center-container">
        <!-- 数据中心卡片 -->
        <el-card class="data-card" shadow="never">
            <el-page-header content="用户管理" icon="database" title="用户管理列表" style="margin-bottom: 20px;" />

            <!-- 用户列表表格 -->
            <el-table :data="tableData" style="width: 100%;" row-key="id" v-loading="tableLoading" stripe>
                <el-table-column prop="id" label="用户ID" />
                <el-table-column prop="user" label="用户名" />
                <el-table-column prop="role" label="权限等级" :formatter="formatRole" />
                <el-table-column label="操作" width="100">
                    <template #default="scope">
                        <el-button v-if="scope.row.role === 'user'" type="danger" :icon="Delete" circle
                            :loading="deletingId === scope.row.id" @click="handleDelete(scope.row)" size="small" />
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script setup>
import {
    Refresh,
    Database,Delete
} from '@element-plus/icons-vue'
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import axios from 'axios'

// 数据状态
const tableData = ref([])
const tableLoading = ref(false)

// 格式化权限等级
const formatRole = (row) => {
    return row.role === 'admin' ? '管理员' : '普通用户'
}

// 数据获取
const fetchData = async () => {
    tableLoading.value = true
    try {
        const res = await axios.get('/adminapi/user/list')
        if (res.data) {
            tableData.value = res.data.results || []
        } else {
            ElMessage.error('数据加载失败')
        }
    } catch (error) {
        console.error('请求错误:', error)
        ElMessage.error('数据加载失败')
    } finally {
        tableLoading.value = false
    }
}

onMounted(() => {
    fetchData()
})

// 操作事件
// 原来叫 handleLook（看着像「查看」）且没有二次确认，一次误点就永久删号，这里补上确认与 loading
const deletingId = ref('')

const handleDelete = async (data) => {
    try {
        await ElMessageBox.confirm(
            `确定删除用户「${data.user}」吗？此操作不可恢复。`,
            '警告',
            { confirmButtonText: '确认删除', cancelButtonText: '取消', type: 'warning' }
        )
    } catch (e) {
        return // 用户取消
    }

    deletingId.value = data.id
    try {
        await axios.delete(`/adminapi/user/del/${data.id}`)
        ElMessage.success('删除成功')
        fetchData()
    } catch (error) {
        console.error('删除用户失败:', error)
        ElMessage.error(error?.response?.data?.message || '删除失败')
    } finally {
        deletingId.value = ''
    }
}

// 说明：原 handleSwitchChange 调用的 /adminapi/user/publish 后端并不存在，
// 且 user 表也没有 audit 字段，属于不可达的死代码，已移除。
</script>

<style lang="scss" scoped>
.data-center-container {
    padding: 20px 30px;
    min-height: calc(100vh - 80px);

    .data-card {
        .el-page-header {
            margin-bottom: 20px;
            padding: 15px 0;
            border-bottom: 1px solid #ebeef5;
        }

        .el-table {
            margin-bottom: 20px;

            thead {
                background-color: #f5f7fa;
            }

            .el-table-column__header {
                color: #303133;
                font-weight: 500;
                padding: 12px 0;
                text-align: center;
            }

            .el-table-cell {
                padding: 12px 0;
                color: #606266;
                text-align: center;
            }
        }
    }
}

::v-deep .el-button--success {
    color: #13ce66;
    border-color: #d6f5e0;
    background-color: #f0fff4;
}

::v-deep .el-button--success:hover {
    color: #0ca651;
    border-color: #a9e9c5;
    background-color: #d6f5e0;
}
</style>